import type { FetchQueryParams } from '@/components/paginated-datatable/types/paginatedDataTableTypes';
import {
  type EmailFilterInnerV2Dto,
  EmailsService,
  type PatchAttachmentClassificationStatusV1Dto,
  type PatchEmailClassificationStatusV1Dto,
} from '@/openapi';

export function useEmails() {
  const fetchEmails = async ({
    filter,
    orderBy,
    page,
    limit,
    isClassifiedFilter,
    searchString,
  }: FetchQueryParams<EmailFilterInnerV2Dto> & {
    isClassifiedFilter: 'all' | 'true' | 'false';
  }) => {
    try {
      return EmailsService.emailControllerV2FindManyWithV2(
        filter,
        orderBy?.length ? orderBy : null,
        page,
        limit,
        undefined,
        undefined,
        isClassifiedFilter,
        undefined,
        searchString,
      );
    } catch (err) {
      console.log(err);
    }
  };

  const fetchEmailsByTicket = async (ticketId: string) => {
    try {
      return EmailsService.emailControllerV1FindManyByTicketIdV1(ticketId);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchEmail = async (id: string) => {
    try {
      return EmailsService.emailControllerV1FindOneV1(id);
    } catch (err) {
      console.log(err);
    }
  };

  const patchAttachmentClassificationStatus = async (
    emailId: string,
    attachmentId: string,
    data: PatchAttachmentClassificationStatusV1Dto,
  ) => {
    await EmailsService.emailControllerV1UpdatePartialAttachmentClassificationStatusV1(
      emailId,
      attachmentId,
      data,
    );
  };

  const patchEmailClassificationStatus = async (
    emailId: string,
    data: PatchEmailClassificationStatusV1Dto,
  ) => {
    await EmailsService.emailControllerV1UpdatePartialEmailClassificationStatusV1(emailId, data);
  };

  return {
    fetchEmails,
    fetchEmail,
    fetchEmailsByTicket,
    patchAttachmentClassificationStatus,
    patchEmailClassificationStatus,
  };
}
